module.exports = __webpack_public_path__ + "statics/img/1.137b533.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo/1.jpg
// module id = Eh+O
// module chunks = 1